<!-- ngView: -->
<div id="contents" role="main" data-ng-view="" class="ng-scope" >
	<section >
			<div class="inner">
				<!--div class="link_bx">
					<a class="seltype_bx" (click)="onPurchase()">
						<h3 class="h3 ng-binding" data-ng-bind-html="'join.samsungcare' | translate | htmlSafe">
							<strong>Join<br>Samsung Care+</strong>
						</h3>
						<i class="sp ico_go ng-binding">Select</i>
					</a>
				</div>
				<div class="link_bx">
					<a class="seltype_bx" (click)="onOrderStatus()">
						<h3 class="h3 ng-binding" data-ng-bind-html="'check.orderStatus' | translate | htmlSafe"><strong>Check
								your<br>coverage status</strong></h3>
						<i class="sp ico_go ng-binding">Select</i>
					</a>
				</div-->
				<div class="main-grid" data-ng-class="{'login': true || vm.isLogin}">
					<ul>
						<li>
							<a (click)="onPurchase()">
								<div class="join-wrapper">
									<div class="join-img"><img src="./assets/images/join-img.jpg"></div>
									<div class="join-text" data-ng-bind-html="'join.samsungcare' | translate | htmlSafe">
										Join
										<h3>Samsung Care+</h3>
										<img src="./assets/images/arrow-right.png" width=30px >
									</div>
								</div>
							</a>
						</li>
						<li>
							<a  (click)="onOrderStatus()">
								<div class="join-wrapper">
									<div class="join-img"><img src="./assets/images/check-img.jpg"></div>
									<div class="join-text" data-ng-bind-html="'check.orderStatus' | translate | htmlSafe">
										Check Your
										<h3>Coverage Status</h3>
										<img src="./assets/images/arrow-right.png" width=30px >
									</div>
								</div>
							</a>
						</li>
					</ul>
				</div>
				<div style="clear:both"></div>
				<div class="service-wrapper">
				<div class="main-subtitle">
					Our Service Suite
				</div>
				<div class="service-grid">
					<img src="./assets/images/service01.jpg">
					<h3>Extended Service Contract</h3>
					<p>Continued protection for mechanical and electrical breakdowns after your manufacturer’s warranty ends.</p>
				</div>
				<div class="service-grid">
					<img src="./assets/images/service02.jpg">
					<h3>Power Surge Coverage</h3>
					<p>If an unexpected power surge causes your appliance or TV to fail, we’ll cover the cost of your repair.</p>
				</div>
				<div class="service-grid">
					<img src="./assets/images/service03.jpg">
					<h3>Dedicated Support</h3>
					<p>Get the most out of your appliance or TV by calling the dedicated line for setup help or troubleshooting.</p>
				</div>
				</div>
				<div class="btn_area">
					<a target="_blank" class="btn btn_type1 btn_layerclose" href="https://www.samsung.com/us/support/samsung-care-plus/home-appliances-and-electronics/faqs/" >VIEW FAQS<img src="./assets/images/button-arrow.png"></a>
				</div>
				<div class="work-wrapper">
					<div class="main-subtitle">
						How does it work?
					</div>
					<div class="work-grid">
						<img src="./assets/images/1.jpg">
						<h3>Enroll in Samsung Care+ during check out</h3>
						<p>The best time to get coverage is right at the beginning of your Samsung journey.</p>
					</div>
					<div class="work-grid">
						<img src="./assets/images/2.jpg">
						<h3>Learn about your Home Appliance or Television</h3>
						<p>A Samsung Care+ Pro is ready to help answer any questions.</p>
					</div>
					<div class="work-grid">
						<img src="./assets/images/3.jpg">
						<h3>Enjoy peace of mind</h3>
						<p>Relax knowing we'll help you get the most out of your product, from troubleshooting, repairs, and beyond. </p>
					</div>
					</div>
				
			</div>
			
			<!--
	<p class="txt_tip ng-binding" data-ng-bind-html="'join.samsungcare.with.account' | translate | htmlSafe">Join
		Samsung Care+ using your Samsung Account by clicking <a href="#" class="link" id="accountMemberJoin">here</a>
	</p>
	-->
		
	</section>
	<!-- <ui-device-list class="ng-scope"></ui-device-list> -->
</div>
<!--
	<div class="form_option">
		<ul class="tips">
			<li data-ng-bind-html="'text.availableDay' | translate | htmlSafe"
				data-ng-show="('text.availableDay' | translate) != '' &amp;&amp; ('text.availableDay' | translate) != 'text.availableDay'"
				class="ng-binding">Sign up to Samsung Care+ within <strong>365 days</strong> of purchase of your eligible
				handset.</li>
		<li data-ng-bind-html="'text.maininfo' | translate | htmlSafe"
			data-ng-show="('text.maininfo' | translate) != '' &amp;&amp; ('text.maininfo' | translate) != 'text.maininfo'"
			class="ng-binding ng-hide">text.maininfo</li>
		<li data-ng-bind-html="'text.foldableinfo' | translate | htmlSafe"
			data-ng-show="('text.foldableinfo' | translate) != '' &amp;&amp; ('text.foldableinfo' | translate) != 'text.foldableinfo'"
			class="ng-binding ng-hide"></li>
		</ul>
	</div>
	-->